module.exports = __webpack_public_path__ + "img/house_pv_panel_off.80974951.png";